import api from '@/lib/api'

const notifyError = (dispatch, error) => {
  dispatch('addTemporalNotification', { type: 'danger', message: error.message })
  return false
}

export default {
  async getPartnersDB ({ dispatch }) {
    try {
      const { payload } = await api.getPartnersAPI()
      return payload
    } catch (error) {
      return notifyError(dispatch, error)
    }
  },
  async updatePartnerDB ({ dispatch }, { partnerId, data }) {
    try {
      const { payload } = await api.updatePartnerAPI(partnerId, data)
      dispatch('addTemporalNotification', { type: 'success', message: 'Partner actualizado' })
      return payload
    } catch (error) {
      return notifyError(dispatch, error)
    }
  },
  async getPartnerPricesDB ({ dispatch }, { partnerId, filters }) {
    try {
      const { payload } = await api.getPartnerPricesAPI(partnerId, filters)
      return payload
    } catch (error) {
      return notifyError(dispatch, error)
    }
  },
  async importPartnerPricesDB ({ dispatch }, { partnerId, file, validFrom, validTo }) {
    try {
      const { payload } = await api.importPartnerPricesAPI(partnerId, file, { validFrom, validTo })
      return payload
    } catch (error) {
      return notifyError(dispatch, error)
    }
  },
  async getPartnerPriceImportsDB ({ dispatch }, partnerId) {
    try {
      const { payload } = await api.getPartnerPriceImportsAPI(partnerId)
      return payload
    } catch (error) {
      return notifyError(dispatch, error)
    }
  },
  async getPartnerPriceImportDB ({ dispatch }, importId) {
    try {
      const { payload } = await api.getPartnerPriceImportAPI(importId)
      return payload
    } catch (error) {
      return notifyError(dispatch, error)
    }
  },
  async downloadPartnerPriceReportDB ({ dispatch }, importId) {
    try {
      return await api.downloadPartnerPriceReportAPI(importId)
    } catch (error) {
      return notifyError(dispatch, error)
    }
  },
  async publishPartnerPriceImportDB ({ dispatch }, importId) {
    try {
      const { payload } = await api.publishPartnerPriceImportAPI(importId)
      dispatch('addTemporalNotification', { type: 'success', message: `Lista publicada (carga #${payload.id})` })
      return payload
    } catch (error) {
      return notifyError(dispatch, error)
    }
  },
  async discardPartnerPriceImportDB ({ dispatch }, importId) {
    try {
      const { payload } = await api.discardPartnerPriceImportAPI(importId)
      dispatch('addTemporalNotification', { type: 'success', message: 'Carga descartada' })
      return payload
    } catch (error) {
      return notifyError(dispatch, error)
    }
  }
}
